export default __webpack_public_path__ + "static/media/KUD_Logo_White.537d35a0.png";